// a quarter note is one beat
// 4 beats in one bar

import PianoUtil from "@/util/piano-util";

// A quarter note at 60bpm will last exactly 1 second (1000ms)
export function calculateNotesDuration(notes, bpm = 60, divisionsPerQuarterNote = 1) {
    let fTime = 0, gTime = 0;

    let notesWithTime = notes.map(note => {
        const duration = calculateNoteDuration(note, bpm, divisionsPerQuarterNote);
        const isGCleff = note.staff === 1;
        note.timeSeconds = isGCleff ? gTime : fTime;
        note.durationSeconds = duration

        if (note.hasOwnProperty('chord') === false) {
            // skip time for chords
            if (isGCleff) {
                gTime += duration;
            } else {
                fTime += duration;
            }
        } else {
            // todo: dirty hack
            // hoping that all notes of chord last same duration
            note.timeSeconds -= note.durationSeconds;
        }

        return note;
    });
    return notesWithTime;
}

// A0 - pianoNote 1
// C8 - 88
const STEP_TO_NUMBER = {
    'C': 4,
    'C#': 5,
    'Db': 5,
    'D': 6,
    'D#': 7,
    'Eb': 7,
    'E': 8,
    'F': 9,
    'F#':10,
    'Gb': 10,
    'G': 11,
    'G#': 12,
    'Ab': 12,
    'A': 13,
    'A#': 14,
    'Bb': 14,
    'B': 15
}

export function calculateStepAndOctave(pianoNote) {
    return PianoUtil.note(pianoNote);
}

export function calculatePianoNote({ step, octave } ) {
    if (octave === 0) {
        switch (step) {
            case 'A': return 1;
            case 'A#': return 2;
            case 'Bb': return 2;
            case 'B': return 3;
        }
    } else {
        return STEP_TO_NUMBER[step] + (octave-1) * 12;
    }
   
} 
function calculateNoteDuration(note, bpm = 120, divisionsPerQuarterNote = 1) {
    const timePerDivision = (60 / bpm) / divisionsPerQuarterNote;
    return note.duration * timePerDivision;
}

export function calculateKey(key) {
    switch (key.mode || "major") {
        case 'minor': {
            switch (key.fifths) {
                case -7: return 'Abm';
                case -6: return 'Ebm';
                case -5: return 'Bbm';
                case -4: return 'Fm';
                case -3: return 'Cm';
                case -2: return 'Gm';
                case -1: return 'Dm';
                case 0: return 'Am';
                case 1: return 'Em';
                case 2: return 'Bm';
                case 3: return 'F#m';
                case 4: return 'C#m';
                case 5: return 'G#m';
                case 6: return 'D#m';
                case 7: return 'A#m';
            }
        }
        case 'major': {
            switch (key.fifths) {
                case -7: return 'Cb';
                case -6: return 'Gb';
                case -5: return 'Db';
                case -4: return 'Ab';
                case -3: return 'Eb';
                case -2: return 'Bb';
                case -1: return 'F';
                case 0: return 'C';
                case 1: return 'G';
                case 2: return 'D';
                case 3: return 'A';
                case 4: return 'E';
                case 5: return 'B';
                case 6: return 'F#';
                case 7: return 'C#';
            }
        }

        
    }
    return 'C';
}


// note.duration can be different for note with a dot, and no dot
// i need the no-dot value
// smallest fraction is 64
export function calcNoteSymbolicDuration(note, divisions) {
    switch (note.type) {
        case 'whole': return 4 * divisions;
        case 'half': return 2 * divisions;
        case 'quarter': return divisions;
        case 'eighth': return divisions / 2;
        case '16th': return divisions / 4;
        case '32nd': return divisions / 8;
        case '64th': return divisions / 16;
    }
}